<template>
    <div>
        <b-modal
            id="editSubscription"
            ref="editSubscription"
            title-tag="h2"
            :lazy="true"
            :title-html="title"
            :no-close-on-esc="isWelcome"
            :no-close-on-backdrop="isWelcome"
            :hide-header-close="isWelcome"
            @shown="shown"
        >
            <!-- Modal Form -->
            <div v-if="message" class="alert alert-danger" role="alert">
                <i class="cus-error"></i>
                {{ message }}
            </div>
            <div v-if="isWelcome">
                Thank you for choosing to partner with us. We hope to help you
                do more of what you love. Please complete the form below to get
                started. If you have any questions, we can be reached at (844)
                4-VETTER.
                <hr />
            </div>
            <div v-else>
                The "Fixed" plan includes unlimited patients and all of the
                premium features, such as wellness plans and online appointment
                booking. Plus, we no longer require an annual contract! Upgrade
                today!
                <hr />
            </div>
            <b-form id="editForm" autocomplete="off" @submit.stop.prevent>
                <b-form-group
                    v-if="!isWelcome && !_.get(config, 'status.PlanType')"
                    label-for="plan"
                    label="Plan:"
                    label-cols="3"
                >
                    <b-form-select id="plan" v-model="plan">
                        <option :value="0">Variable</option>
                        <option :value="1">Fixed</option>
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    v-if="plan === 1"
                    label-for="plan"
                    label="Users:"
                    label-cols="3"
                >
                    <b-form-select
                        id="plan"
                        v-model="num_user"
                        :disabled="loading"
                    >
                        <b-form-select-option
                            v-for="option in price_options"
                            :key="option.user"
                            :value="option"
                        >
                            {{ option.description }}
                        </b-form-select-option>
                    </b-form-select>
                </b-form-group>
                <div v-if="plan === 0">
                    <b-form-group
                        label-for="user_numbers"
                        label="Staff:"
                        label-cols="3"
                    >
                        <b-form-select
                            v-if="_.get(config, 'status.UserQuota') != -1"
                            id="user_numbers"
                            v-model="user_numbers"
                            :disabled="true"
                            :options="staff_options"
                        ></b-form-select>
                        <p v-else class="plain-text">Unlimited</p>
                    </b-form-group>
                    <b-form-group
                        label-for="patient_numbers"
                        label="Patients:"
                        label-cols="3"
                    >
                        <b-form-select
                            v-if="_.get(config, 'status.PatientQuota') != -1"
                            id="patient_numbers"
                            v-model="patient_numbers"
                            :disabled="true"
                            :options="patient_options"
                        ></b-form-select>
                        <p v-else class="plain-text">Unlimited</p>
                    </b-form-group>
                    <b-form-group
                        v-if="!isWelcome"
                        label-for="extensions"
                        label="Extensions:"
                        label-cols="3"
                    >
                        <strong id="extensions" class="plain-text">
                            ${{
                                _.get(
                                    config,
                                    "price.extension_fee",
                                    0
                                ).toFixed()
                            }}
                            / month
                        </strong>
                    </b-form-group>
                    <b-form-group
                        label-for="total_fee"
                        label="Total Fee:"
                        label-cols="3"
                    >
                        <strong id="extensions" class="plain-text"
                            >${{ total_fee }} / month</strong
                        >
                    </b-form-group>
                </div>
                <payment-form
                    v-if="isWelcome"
                    ref="paymentForm"
                    :data="payment_data"
                    @loading="loading = true"
                    @loaded="loading = false"
                />
                <b-form-group
                    v-else
                    label-for="payment_method"
                    label="Payment Method:"
                    label-cols="3"
                >
                    <p v-if="config.payment" class="plain-text">
                        {{ _.get(config, "payment.name") }}
                    </p>
                    <vet-select
                        v-else
                        id="payment_method_name"
                        v-model="data.payment_method_name"
                        v-validate="'required'"
                        :is-extension="'3'"
                        cc-processor="CCONNECT"
                        :class="{
                            'border-danger': errors.has('payment_method_name')
                        }"
                        entity="business"
                        cardconnect_iframe_url=""
                        placeholder="Payment Method (required)"
                        name="payment_method_name"
                    />
                </b-form-group>
            </b-form>
            <div slot="modal-footer" class="w-100">
                <b-btn
                    v-if="!loading && !isWelcome"
                    class="float-left"
                    variant="secondary"
                    @click="$refs.editSubscription.hide()"
                    >Cancel</b-btn
                >
                <b-btn
                    v-else
                    class="float-left"
                    variant="secondary"
                    @click="logoutSite"
                    >Logout</b-btn
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button
                        v-else-if="isWelcome"
                        variant="primary"
                        form="editForm"
                        type="submit"
                        @click="save"
                        >Get Started!</b-button
                    >
                    <b-button
                        v-else-if="plan != 0"
                        variant="primary"
                        form="editForm"
                        type="submit"
                        disabled
                        >Update</b-button
                    >
                    <!-- TEMPORARILY DISABLE BUTTON -->
                    <!-- BELOW IS THE ORIGINAL CODE FOR THE SUBMIT BUTTONS -->
                    <!-- <b-button
                        v-else-if="isWelcome"
                        variant="primary"
                        form="editForm"
                        type="submit"
                        @click="save"
                        >Get Started!</b-button
                    >
                    <b-button
                        v-else-if="plan != 0"
                        variant="primary"
                        form="editForm"
                        type="submit"
                        @click="save"
                        >Update</b-button
                    > -->
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
/* eslint-disable indent */
import vetSelect from "@/module/commons/vet-payment-method.vue";
import { get, isNaN, find, omit } from "lodash";
import PaymentForm from "@/module/commons/payment_method/form";

export default {
    name: "EditSubscription",
    components: {
        vetSelect,
        PaymentForm
    },
    data() {
        return {
            data: {
                staff: null,
                staff_id: null,
                password: null
            },
            config: {},
            staffList: [],
            loading: false,
            message: null,
            patient_options: [],
            staff_options: [],
            user_numbers: null,
            patient_numbers: null,
            module: "edit",
            plan: 0,
            num_user: "",
            payment_data: {
                id: null,
                name_on_card: null,
                card_number: null,
                expiry_month: "",
                expiry_year: "",
                security_code: null,
                is_primary: "1",
                existing_pmp: 0,
                direct: -1,
                cardconnect_iframe_url: "",
                mytoken: "",
                myexpiry: "",
                myerror: ""
            },
            price_options: []
        };
    },
    computed: {
        new_fee() {
            if (this.plan === 1) {
                return this.num_user.price;
            } else {
                let fee =
                    get(this, "user_numbers.fee", 0) +
                    get(this, "patient_numbers.fee", 0);

                return isNaN(fee) ? "" : fee;
            }
        },
        total_fee() {
            return (
                parseFloat(this.new_fee) +
                get(this, "config.price.extension_fee", 0)
            );
        },
        isWelcome() {
            return this.module === "welcome";
        },
        title() {
            return (
                '<i class="famfamfam-silk lock"></i> ' +
                (!this.isWelcome ? "Edit Subscription" : "Welcome")
            );
        }
    },
    methods: {
        filterApplyDiscount(
            rawOptions = [],
            userSub,
            tiers = [],
            discountPercent
        ) {
            let arr = [];
            let activeUser = this.config.user.active || 1; // if 0, null, fallback to 1
            let filtered = rawOptions.filter(tier => tier.user >= activeUser);

            if (tiers.length) {
                filtered = tiers;
            }

            for (let option of filtered) {
                // let user = option.user;
                let user = option.tier ?? option.user;
                let description = option.description ?? "";
                let price = option.price;
                // let discount = this.config.status.Discount || 0; // update discount to 0, discount handle by zuora
                let discount = 0; // [09082023] VET-2029 : update discount to 0 because of pricing issue

                let newDiscount = 0;

                if (discount !== 0) {
                    newDiscount = discount;
                } else if (discountPercent !== 0) {
                    newDiscount = discountPercent;
                }

                price = Math.round(price - (price * newDiscount) / 100);
                let priceLabel = price.toFixed(0);

                if (option.user && user === 1) {
                    description = `1 user ($${priceLabel} / month)`;
                } else {
                    description = `Up to ${user} users ($${priceLabel} / month)`;
                }

                arr.push({
                    description,
                    price,
                    user
                });
            }

            return arr;
        },
        async loadPrice() {
            try {
                let res = await this.$http.get(
                    process.env.BARRAMUNDI + "account/subscription/price-tier"
                );

                let zuoraSubs = await this.$http.post(
                    process.env.BARRAMUNDI + "api/zuora/account/subscription"
                );

                let response = res.data.response;
                let zuoraRes =
                    zuoraSubs.data && zuoraSubs.data.resources
                        ? zuoraSubs.data.resources.subscriptions
                        : null;
                let rawOptions = [];

                if (response && response.resources) {
                    rawOptions = response.resources;
                } else {
                    throw new Error("Unable to load price options.");
                }

                // set user quantity base on zuora
                // loop subscriptions, only list vet subscriptions
                // set latest quantity
                let userSub = 0;
                let discountPercent = 0;
                let tiers = [];
                let contZuora = true;

                if (zuoraRes) {
                    zuoraRes.forEach(subs => {
                        if (
                            contZuora &&
                            subs &&
                            (subs.status == "Active" ||
                                subs.status == "Cancelled")
                        ) {
                            subs.ratePlans.forEach(ratePlan => {
                                if (ratePlan) {
                                    if (
                                        ratePlan.lastChangeType !== undefined &&
                                        ratePlan.lastChangeType == "Remove"
                                    ) {
                                        contZuora = false;
                                    }

                                    if (
                                        contZuora &&
                                        ratePlan.ratePlanCharges.length
                                    ) {
                                        if (
                                            ratePlan.ratePlanName.includes(
                                                "Vet Subscription Per User"
                                            )
                                        ) {
                                            userSub =
                                                ratePlan.ratePlanCharges[0]
                                                    .quantity;

                                            tiers =
                                                ratePlan.ratePlanCharges[0]
                                                    .tiers;
                                        }

                                        if (subs.status == "Active") {
                                            ratePlan.ratePlanCharges.forEach(
                                                charges => {
                                                    discountPercent +=
                                                        charges.discountPercentage;
                                                }
                                            );
                                        }
                                        contZuora = false;
                                    }
                                }
                            });
                        }
                    });
                }
                let options = this.filterApplyDiscount(
                    rawOptions,
                    userSub,
                    tiers,
                    discountPercent
                );

                let key = 0;
                options.forEach((quota, index) => {
                    if (quota.user == userSub) {
                        key = index;
                    }
                });

                if (options[key]) {
                    this.price_options = options;
                    this.num_user = options[key];
                } else {
                    this.price_options = rawOptions;
                    this.num_user = rawOptions[0];
                }
            } catch (error) {
                this._message(error.message, "danger");
            }
        },
        logoutSite() {
            if (typeof newrelic !== "undefined") {
                // eslint-disable-next-line no-undef
                newrelic.addPageAction("view-logout", {
                    reason: "logout",
                    file: "subscription/edit.vue"
                });
            }
            window.location = process.env.APPS + "index.php/welcome/logout";
        },
        async open(params) {
            this.loading = true;
            this.module = params.module;

            let data = await this._getSubscriptionConfig();
            this.config = data;

            this.staff_options = this.interval({
                active: data.user.active,
                quota: data.status.UserQuota,
                price_block: data.user.price,
                initial_price_block: data.user.initial_price,
                block: data.user.block,
                free: data.user.free,
                is_custom: data.price.is_custom,
                unlimited_price: data.user.unlimited
            });

            this.patient_options = this.interval({
                active: data.patient.active,
                quota: data.status.PatientQuota,
                price_block: data.patient.price,
                initial_price_block: data.patient.initial_price,
                block: data.patient.block,
                free: data.patient.free,
                is_custom: data.price.is_custom,
                unlimited_price: data.patient.unlimited
            });

            let current_user_quota = find(this.staff_options, {
                index: this.config.status.UserQuota
            });

            this.user_numbers =
                this.config.status.UserQuota !== -1 && current_user_quota
                    ? current_user_quota.value
                    : this.staff_options[0].value;

            let current_patient_quota = find(this.patient_options, {
                index: this.config.status.PatientQuota
            });

            this.patient_numbers =
                this.config.status.PatientQuota !== -1 && current_patient_quota
                    ? current_patient_quota.value
                    : this.patient_options[0].value;

            this.payment_data.cardconnect_iframe_url =
                data.cardconnect_iframe_url;

            this.plan = this.isWelcome
                ? 1
                : this.config.status.PlanType
                ? this.config.status.PlanType
                : 0;

            await this.loadPrice();
            this.$refs.editSubscription.show();

            if (!this.isWelcome) {
                this.loading = false;
            }
        },
        shown() {},
        interval(params) {
            let interval = [];
            let min = params.free;
            let max = 0;

            if (params.active > params.free) {
                min = Math.ceil(params.active / params.block) * params.block;
            }

            if (params.unlimited_price) {
                max =
                    Math.ceil(params.unlimited_price / params.price_block) *
                        params.block +
                    params.free;
            } else {
                max = params.quota + params.free;
            }

            if (min >= max) {
                max = min + 1;
            }

            for (let i = min; i <= max - 1; i += params.block) {
                let fee = 0;
                if (i - params.free > 0) {
                    // --- new pricing; initial user & patient is 15 each
                    if (
                        i - params.free === params.block &&
                        params.initial_price_block
                    ) {
                        fee = Math.ceil(
                            ((i - params.free) / params.block) *
                                params.initial_price_block
                        );
                        interval.push({
                            value: { index: i, fee },
                            text: i + " - ($" + fee + " / month)",
                            index: i
                        });
                    } else {
                        if (!params.is_custom && params.initial_price_block) {
                            fee = Math.ceil(
                                params.initial_price_block +
                                    ((i - params.free) / params.block) *
                                        params.price_block -
                                    params.price_block
                            );
                            interval.push({
                                value: { index: i, fee },
                                text: i + " - ($" + fee + " / month)",
                                index: i
                            });
                        } else {
                            if (params.is_custom) {
                                fee = Math.ceil(
                                    ((i - params.free) / params.block) *
                                        params.price_block
                                );
                                interval.push({
                                    value: { index: i, fee },
                                    text: i + " - ($" + fee + " / month)",
                                    index: i
                                });
                            } else {
                                fee = Math.ceil(
                                    ((i - params.free) / params.block) *
                                        params.initial_price_block
                                );
                                interval.push({
                                    value: { index: i, fee },
                                    text: i + " - ($" + fee + " / month)",
                                    index: i
                                });
                            }
                        }
                    }
                } else {
                    interval.push({
                        value: { index: i, fee },
                        text: i + " - Free",
                        index: i
                    });
                }
            }

            return interval;
        },
        async save() {
            const sleep = m => new Promise(r => setTimeout(r, m));
            let cont = true;
            this.loading = true;
            let response = null;
            // eslint-disable-next-line no-unused-vars
            let error_msg =
                "Your subscription could not be updated because \
                the staff or patient subscriptions were not changed.";
            let params = {
                id: get(this, "$root.setting.business_id"),
                new_fee: this.new_fee,
                subscription_type: "CCONNECT",
                extension_fee: get(this, "config.price.extension_fee"),
                user_numbers: this.user_numbers.index,
                patient_numbers: this.patient_numbers.index,
                add_payment_permission: this._hasAccess("setting.payment.add")
                    ? 1
                    : 0,
                plan: this.plan,
                start: moment().tz(this._timeZone).format(this.getDateFormat())
            };

            if (
                this.isWelcome &&
                !(await this.$refs.paymentForm.$validator.validateAll())
            ) {
                this.loading = false;
                return;
            }

            if (this.isWelcome) {
                omit(params, ["user_num_edit", "payment_method_id"]);
                params.name_on_card = this.payment_data.name_on_card;
                params.is_new_subscription = true;
                params.user_num_new = this.num_user.user;

                await sleep(2500);

                params.mytoken = this.payment_data.mytoken;
                params.myexpiry = this.payment_data.myexpiry;

                if (params.mytoken !== "" && params.myexpiry !== "") {
                    // do nothing
                } else {
                    cont = false;
                    let err = this.payment_data.myerror;

                    if (err !== "") {
                        if (err === "Invalid Account Number") {
                            this._message("Invalid card number", "danger");
                        }

                        if (err === "Invalid CVV") {
                            this._message("Invalid security code", "danger");
                        }

                        if (err === "Invalid Expiry")
                            this._message("Invalid expiration date", "danger");
                    }

                    this.loading = false;
                }
            } else {
                params.user_num_edit = this.num_user.user;
                params.payment_method_id = get(this, "config.payment.id", null);
            }

            if (cont === true) {
                try {
                    response = await this.$http.post(
                        process.env.APPS +
                            "index.php/business/subscription/save",
                        $.param(params)
                    );

                    if (response.data && response.data.code !== 400) {
                        this._message(response.data.message);
                        this.$refs.editSubscription.hide();
                        this.$root.$emit("subscription-updated", {
                            variant: false,
                            refresh: false
                        });
                    } else {
                        this._message(response.data.message, "danger");
                        this.loading = false;
                    }
                } catch (error) {
                    this._message(error.message, "danger");
                    this.loading = false;
                }
            }

            /* current_user_quota: -1
            new_users_quota: 11
            current_active_users: 11
            current_patient_quota: -1
            new_patient_quota: 200
            current_active_patients: 129
            current_storage_quota: 5
            current_active_storage: 0.00000
            current_sms_subscribe: ENABLED
            current_sms_price: 0.02
            id: 6e13a9da-74c6-49
            new_fee: 500
            current_fee: 500
            extension_fee: 98
            is_changed: 0
            payment_method_id:
            start:
            subscription_type: CCONNECT
            add_payment_permission: 1
            is_new_subscription: true
            plan: 1
            user_numbers: 11
            patient_numbers: 200
            payment_method_name:
            name_on_card: 123123
            card_number: 21313
            expiry_month: 02
            expiry_year: 2024 */
        }
    }
};
</script>
